<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center justify-content-between">
            <h4>{{ isEdit ? 'ویرایش تبلیغ' : 'ساخت تبلیغ جدید' }}</h4>
            <div>
              <button class="btn btn-secondary ml-2" @click="goBack">بازگشت</button>
              <button v-if="isEdit" class="btn btn-danger" @click="deleteAd">حذف</button>
            </div>
          </div>
          <div class="widget-body">
            <form class="form-horizontal" v-on:submit.prevent>
              <div class="row">
                <div class="col-lg-6">
                  <label class="form-control-label">محل نمایش تبلیغ</label>
                  <select class="form-control mt-2 mb-2" v-model="form.tag" required>
                    <option disabled value="">انتخاب کنید</option>
                    <option v-for="tagOption in tagOptions" :key="tagOption.value" :value="tagOption.value">
                      {{ tagOption.label }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-3">
                  <label class="form-control-label">نوع تبلیغ</label>
                  <select class="form-control" v-model="form.adType">
                    <option value="impression">نمایشی (impression)</option>
                    <option value="click">کلیکی (click)</option>
                  </select>
                </div>

                <div class="col-lg-6">
                  <div class="group material-input mt-2 mb-2">
                    <input type="number" v-model.number="form.order" />
                    <span class="bar"></span>
                    <label>ترتیب</label>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="group material-input mt-2 mb-2">
                    <input type="text" v-model="form.link" />
                    <span class="bar"></span>
                    <label>لینک (در صورت کلیک)</label>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group row d-flex align-items-center mb-3">
                    <label class="col-lg-4">قابل کلیک</label>
                    <div class="col-lg-8">
                      <input type="checkbox" v-model="form.isClickable" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group row d-flex align-items-center mb-3">
                    <label class="col-lg-4">فعال</label>
                    <div class="col-lg-8">
                      <input type="checkbox" v-model="form.isAvailable" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 mb-3">
                  <label class="col-lg-4 p-0">نمایش از</label>
                  <date-picker
                    type="datetime"
                    inputFormat="YYYY-MM-DD HH:mm"
                    display-format="jYYYY-jMM-jDD HH:mm"
                    format="YYYY-MM-DDTHH:mm:SSZ"
                    locale="fa,en"
                    v-model="form.fromDate"
                  ></date-picker>
                </div>

                <div class="col-lg-6 mb-3">
                  <label class="col-lg-4 p-0">نمایش تا</label>
                  <date-picker
                    type="datetime"
                    inputFormat="YYYY-MM-DD HH:mm"
                    display-format="jYYYY-jMM-jDD HH:mm"
                    format="YYYY-MM-DDTHH:mm:SSZ"
                    locale="fa,en"
                    v-model="form.toDate"
                  ></date-picker>
                </div>

                <div class="col-lg-12 mb-3">
                  <label>تصویر تبلیغ</label>
                  <input type="file" accept="image/*" @change="fileSelected" />
                  <div class="mt-2">
                    <a v-if="form.imageAddress" :href="form.imageAddress" target="_blank">مشاهده تصویر فعلی</a>
                  </div>
                </div>
              </div>

              <div class="em-separator separator-dashed"></div>
              <div class="text-right">
                <button class="btn btn-gradient-01" @click="saveAd">ذخیره</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import advertisementService from '../../../../services/advertisementService';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import moment from 'moment';

export default {
  name: 'AdvertisementEdit',
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      isLoading: false,
      file: null,
      tagOptions: [
        { value: 'Splash_banner_up', label: 'اسپلش بالا (Splash Up)' },
        { value: 'Splash_banner_down', label: 'اسپلش پایین (Splash Down)' },
        { value: 'Main_menu_banner', label: ' منوی اصلی - بنر بالا بزرگ' },
        { value: 'Main_menu_banner_2', label: 'منوی اصلی - بنر  دکمه ای کوچک' },
        { value: 'Customize_banner', label: 'شخصی سازی (Customize)' },
        { value: 'Find_opponent_banner', label: 'یافتن حریف (Find Opponent)' },
        { value: 'Stadium_banner', label: 'یافتن استادیوم (Find Stadium)' },
        { value: 'Lucky_spin_banner', label: 'چرخ شانس (Lucky Spin)' },
        { value: 'League_banner', label: ' لیگ (Main Menu League)' },
        { value: 'Game_banner_up_left', label: 'بازی - بالا چپ' },
        { value: 'Game_banner_up_right', label: 'بازی - بالا راست' },
        { value: 'Game_banner_down_left', label: 'بازی - پایین چپ' },
        { value: 'Game_banner_down_right', label: 'بازی - پایین راست' },
        { value: 'League_banner_up_left', label: 'لیگ - بالا چپ' },
        { value: 'League_banner_up_right', label: 'لیگ - بالا راست' },
        { value: 'League_banner_down_left', label: 'لیگ - پایین چپ' },
        { value: 'League_banner_down_right', label: 'لیگ - پایین راست' },
      ],
      form: {
        tag: '',
        adType: 'impression',
        order: 0,
        link: '',
        isClickable: false,
        isAvailable: true,
        fromDate: null,
        toDate: null,
        imageAddress: null,
      },
    };
  },
  computed: {
    adId() {
      return this.$route.params.id;
    },
    isEdit() {
      return this.adId != null;
    },
  },
  created() {
    if (this.isEdit) {
      this.loadAd();
    }
  },
  methods: {
    goBack() {
      this.$router.push('/dashboard/advertisements');
    },
    fileSelected(e) {
      this.file = e.target.files[0];
    },
    obj2FormData(obj, formData = new FormData()) {
      const data = formData;
      function createFormData(o, subKeyStr = '') {
        for (const i in o) {
          const value = o[i];
          const subKeyStrTrans = subKeyStr ? `${subKeyStr}[${i}]` : i;
          if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            data.append(subKeyStrTrans, value);
          } else if (typeof value === 'object' && value !== null) {
            createFormData(value, subKeyStrTrans);
          }
        }
      }
      createFormData(obj);
      return data;
    },
    async loadAd() {
      this.isLoading = true;
      try {
        const ad = await advertisementService.findAdvertisementById(this.adId);
        this.form = {
          ...this.form,
          ...ad,
          link: ad.link || '',
          order: ad.order ?? 0,
          isClickable: ad.isClickable ?? false,
          isAvailable: ad.isAvailable ?? true,
        };
      } catch (err) {
        window.notif({ isError: true, mssg: 'تبلیغ پیدا نشد' });
        this.goBack();
      } finally {
        this.isLoading = false;
      }
    },
    async saveAd() {
      try {
        if (!this.form.tag || !this.form.adType) {
          window.notif({ isError: true, mssg: 'برچسب و نوع تبلیغ الزامی است' });
          return;
        }

        const body = {
          tag: this.form.tag,
          adType: this.form.adType,
          order: this.form.order ?? 0,
          link: this.form.link || '',
          isClickable: this.form.isClickable ?? false,
          isAvailable: this.form.isAvailable ?? true,
        };

        const data = this.obj2FormData(body);

        if (this.file) {
          data.append('file', this.file);
        }

        if (this.form.fromDate) {
          data.append('fromDate', moment(this.form.fromDate, 'YYYY-MM-DDTHH:mm:SSZ').toISOString());
        }

        if (this.form.toDate) {
          data.append('toDate', moment(this.form.toDate, 'YYYY-MM-DDTHH:mm:SSZ').toISOString());
        }

        if (this.isEdit) {
          data.append('id', this.adId);
          await advertisementService.updateAdvertisement(data);
          window.notif({ isError: false, mssg: 'تبلیغ بروزرسانی شد' });
        } else {
          if (!this.file) {
            window.notif({ isError: true, mssg: 'تصویر را انتخاب کنید' });
            return;
          }
          await advertisementService.createAdvertisement(data);
          window.notif({ isError: false, mssg: 'تبلیغ ایجاد شد' });
        }

        this.goBack();
      } catch (err) {
        const backendMessage = err?.response?.data?.message;
        if (backendMessage === 'tag duration overlap') {
          window.notif({ isError: true, mssg: 'برای این محل نمایش، بازه زمانی با تبلیغ دیگری همپوشانی دارد' });
          return;
        }
        if (backendMessage === 'invalid date range') {
          window.notif({ isError: true, mssg: 'بازه تاریخ نامعتبر است' });
          return;
        }
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده، بعدا تلاش کنید' });
      }
    },
    async deleteAd() {
      try {
        await advertisementService.deleteAdvertisement(this.adId);
        window.notif({ isError: false, mssg: 'تبلیغ حذف شد' });
        this.goBack();
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده، بعدا تلاش کنید' });
      }
    },
  },
};
</script>
